import angular from 'angular'

// components
import filterList from './component/filterList.js'

export default angular
  .module('portalApp.filterList', [])
  .component('filterList', filterList)
  .name
